/**
 * Viblast either doesn't like all the redirects that happen in our live stream url
 * or doesn't like something about one of the urls returned, so we get a sanitized
 * version of the livestream ourselves.
 * @param {String} station station name
 * @return {Promise} with URL of Empire hosted livestream or error
 */
export const getLiveStreamUrl = station => {  // eslint-disable-line arrow-body-style
  return new Promise((resolve, reject) => {
    fetch(`${location.protocol}//${station}.streamon.fm/hls/${station.toUpperCase()}.m3u8`)
    .then(resp => resp.text())
    .then(data => {
      const regEx = /http.*\.m3u8/;
      const nextUrl = regEx.exec(data)[0];

      fetch(nextUrl)
        .then(resp2 => resp2.url)
        .then(url => resolve(url))
        .catch(e2 => reject(e2));
    })
    .catch(e => reject(e));
  });
};



// WEBPACK FOOTER //
// ./src/utils/utils.js